import { IAdhocInvoice } from "../../../../api/hooks/useAdhocInvoices";
import {
  ADHOC_STATUS_COLOR_MAP,
  AdhocInvoiceResponse,
  BadgeTypography,
} from "@synota-io/synota-shared-ui";

export const AdhocStatusCell = ({ invoice }: { invoice: IAdhocInvoice }) => {
  if (!invoice.status) {
    return null;
  }

  return (
    <BadgeTypography
      width="100%"
      variant="subtitle3"
      status={ADHOC_STATUS_COLOR_MAP[invoice.status as AdhocInvoiceResponse["status"]]}
    >
      {invoice.status}
    </BadgeTypography>
  );
};
